import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        currentCall: null,
        showOutcoming: false,
        device: null,
    },
    mutations: {
        currentCall(state, call) {
            state.currentCall = call;
        },
        showOutcoming(state, show) {
            state.showOutcoming = show;
        },
        setDevice(state, val) {
            state.device = val;
        }
    },
    actions: {
        setDevice(context, val) {
            context.commit('setDevice', val);
        }
    }
})
